export const USER_TYPE = 'user'
export const ORG_TYPE = 'org'
export const API_CLIENT_GENERATION = 'apiClient'
export const API_USER_CLIENT_GENERATION = 'apiUserClient'
export const SEND_CONTACT_FORM = 'sendContactForm'